var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-your-plan"},[_c('header-page',{attrs:{"title":_vm.$route.meta.title}}),_vm._v(" "),_c('div',{staticClass:"plan-content"},[_c('your-plan-summary')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbf64e88","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/your-plan/page-your-plan.vue
// module id = 1717
// module chunks = 46